import { css } from '@emotion/css';

export const notFoundDescriptionClassName = css({
  fontWeight: 400,
});
